import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AnalyticsService } from '../../../../../../services/analytics/index'
import { AttributeFormatter } from '../../formatters/attribute'
import { UserAttrFormatter } from '../../formatters/user'
import { PageEvents } from '../../page-events'
import { MparticleEvent } from '../mparticle-event'

const mParticleEvents: any = new PageEvents()

export class Subscription extends MparticleEvent {

    public attributeFormatter = new AttributeFormatter()
    public userAttrFormatter = new UserAttrFormatter()
    /**
     * Handle an account confirmed event
     */
    public handle(): void {

        /**
         * @var attrs will be different for each
         * events
         *
         * there are events which has will have attributes
         * both from dom element and page meta properties
         */

        const attrs = [
            key.DOMAIN
        ]

        let evtName: string

        switch (this.type) {
            case AnalyticsService.pageLoadEventTypes.signin:
                evtName = PageEvents.mpEventName.Signin
                attrs.push(key.USER_SIGNIN_MTHD)
                break
            case AnalyticsService.pageLoadEventTypes.newReg:
                evtName = PageEvents.mpEventName.NewReg
                attrs.push(key.TRUE_FALSE)
                break
            case AnalyticsService.pageLoadEventTypes.regThankScreen:
                evtName = PageEvents.mpEventName.RegThankScreen
                break
            case AnalyticsService.pageLoadEventTypes.verificationScreen:
                evtName = PageEvents.mpEventName.VerificationScreen
                break
            case AnalyticsService.pageLoadEventTypes.creditCardInfo:
                evtName = PageEvents.mpEventName.CreditCardInfo
                break
            case AnalyticsService.pageLoadEventTypes.accountConfirmed:
                evtName = PageEvents.mpEventName.AccountConfirmed
                attrs.push(key.USER_ACNT_STATUS)
                break
            case AnalyticsService.clickEventTypes.subscriptionButton:
                evtName = PageEvents.mpEventName.SubscriptionButton
                attrs.push(key.BTN_LOC)
                break
            case AnalyticsService.clickEventTypes.signinRegModule:
                evtName = PageEvents.mpEventName.SigninRegModule
                attrs.push(key.USER_VIEW_SIGN_REG_MODULE)
                break
            case AnalyticsService.clickEventTypes.signout:
                evtName = PageEvents.mpEventName.Signout
                attrs.push(key.TRUE_FALSE)
                break
            case AnalyticsService.clickEventTypes.accountModal:
                evtName = PageEvents.mpEventName.AccountModal
                break
        }

        const data = this.attributeFormatter.format(
            attrs,
            {
                ...this.metaProperties,
                ...this.userAttrFormatter.format(
                    this.getProperties()
                )
            }
        )

        mParticleEvents.logEvent(
            String(evtName),
            PageEvents.mpEventType.UserPreference,
            data
        )
    }
}
